import { Module } from 'vuex';

import { LearningPathInfo, RootState } from 'frontend/types';

export interface RecommendedLearningPathState {
  recommendedPaths: LearningPathInfo[];
}

const recommendedLearningPathInfo: Module<RecommendedLearningPathState, RootState> = {
  namespaced: true,
  state: {
    recommendedPaths: [],
  } as RecommendedLearningPathState,
  getters: {
    learningPaths: (state: RecommendedLearningPathState): LearningPathInfo[] => {
      return state.recommendedPaths;
    },
  },
  mutations: {
    setValue(state: RecommendedLearningPathState, value: LearningPathInfo[]): void {
      state.recommendedPaths = value;
    },
  },
  actions: {},
};

export default recommendedLearningPathInfo;
